export enum Sections {
  allResults = 'allResults',
  draftApplications = 'draftApplications',
  submittedApplications = 'submittedApplications',
  users = 'users',
  quotes = 'quotes',
}
